module.exports = __webpack_public_path__ + "static/large-product-finder-b050ea5b67523f9caac69501f4c077bc.png";